import clsx from 'clsx';

export interface StatCard {
  label: string;
  value: string | number;
  format?: 'currency' | 'number' | 'percent';
  delta?: string;
  deltaDir?: 'up' | 'down' | 'neutral';
}

interface Props {
  cards: StatCard[];
}

function formatValue(card: StatCard): string {
  if (typeof card.value === 'string') return card.value;
  const v = Number(card.value);
  if (card.format === 'currency') return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(v);
  if (card.format === 'percent')  return `${v.toFixed(1)}%`;
  return new Intl.NumberFormat('en-US').format(v);
}

export function StatCards({ cards }: Props) {
  return (
    <div className="grid grid-flow-col auto-cols-fr gap-3">
      {cards.map((c, i) => (
        <div key={i} className="bg-surface border border-border rounded-lg px-4 py-3">
          <div className="text-[10px] uppercase tracking-[0.7px] text-text-hint">{c.label}</div>
          <div className="text-[20px] font-medium text-text-primary mt-1">{formatValue(c)}</div>
          {c.delta && (
            <div className={clsx('text-[11px] mt-0.5',
              c.deltaDir === 'up'   && 'text-success',
              c.deltaDir === 'down' && 'text-danger',
              c.deltaDir === 'neutral' && 'text-text-muted',
            )}>{c.delta}</div>
          )}
        </div>
      ))}
    </div>
  );
}
